import { render } from "./DirectoryHubBanner.vue?vue&type=template&id=ebd7ccb0&scoped=true"
import script from "./DirectoryHubBanner.vue?vue&type=script&lang=js"
export * from "./DirectoryHubBanner.vue?vue&type=script&lang=js"

import "./DirectoryHubBanner.vue?vue&type=style&index=0&id=ebd7ccb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd7ccb0"]])

export default __exports__